import React from 'react';
import SourceFieldset from '@/features/quickSetup/SourceFieldset';
import WizardFormLayout from '@/features/quickSetup/WizardFormLayout';
import type { QuickSetupFormState } from '@/features/quickSetup/types';
import type { Source } from '@/types';

type Props = {
  form: QuickSetupFormState;
  sources: Source[];
  onChange: (patch: Partial<QuickSetupFormState>) => void;
  onToggleSource: (name: string) => void;
  onSetSourceNames?: (names: string[]) => void;
  sourcesEmptyHint?: string;
};

export default function CustomWizard({
  form,
  sources,
  onChange,
  onToggleSource,
  onSetSourceNames,
  sourcesEmptyHint,
}: Props) {
  return (
    <WizardFormLayout
      aside={
        <SourceFieldset
          sources={sources}
          selected={form.source_names}
          onToggle={onToggleSource}
          onSetSelected={onSetSourceNames}
          emptyHint={sourcesEmptyHint}
        />
      }
    >
      <div className="wizard-field-grid">
        <p className="muted wizard-field-span-2 wizard-hint">
          Advanced mode — use search text plus optional JSON for extra filter keys. Values are
          stored in <code>filters_json</code> only.
        </p>

        <label className="wizard-field-span-2">
          Search text
          <input
            value={form.search_text}
            onChange={(e) => onChange({ search_text: e.target.value })}
            placeholder="Primary query"
          />
        </label>

        <label className="wizard-field-span-2">
          Extra filters (JSON)
          <textarea
            rows={6}
            value={form.custom_filters}
            onChange={(e) => onChange({ custom_filters: e.target.value })}
            placeholder={'{\n  "color": "red",\n  "mileage_max": 150000\n}'}
            className="mono-input"
          />
        </label>
      </div>
    </WizardFormLayout>
  );
}
